// Complex MenuBar

import React from "react";
import PropTypes from "prop-types";
import onResize from "../../hoc/onResize";
import TopNav from "./TopNav";
import BottomNav from "./BottomNav";
import SideBar from "./SideBar";

export class MenuBar extends React.Component {
  render() {
    const {
      user,
      entity,
      website,
      assets,
      menu,
      menu: { menu_links, countdown_campaign: campaign, display_search },
      current_campaign,
    } = this.props;

    return (
      <div id="complex-menu-bar">
        {(display_search || (menu_links && menu_links.length > 0)) && (
          <SideBar links={menu_links} displaySearch={display_search} entity={entity} />
        )}
        <TopNav website={website} entity={entity} menu={menu} />
        <BottomNav
          user={user}
          links={menu_links}
          entity={entity}
          menu={menu}
          assets={assets}
          hasExternalUrls={entity.urls.length > 0}
          campaign={current_campaign || campaign}
        />
        {/* needed div for sticky nav */}
        <div></div>
      </div>
    );
  }
}

MenuBar.propTypes = {
  entity: PropTypes.object.isRequired,
  menu: PropTypes.object.isRequired,
  user: PropTypes.object,
};

export default onResize(MenuBar);
